import { STOModel } from "../../../models/base/sto-model";
import { SplittingEmployeeDocumentFilesResultDTO } from "../../../models/split-document/split-employee-document/splitting-employee-document-files-result-dto";
import { BaseApiService } from "../../../services/base";

export class ProcessSplitEmployeeDocumentApiService extends BaseApiService<
  SplittingEmployeeDocumentFilesResultDTO,
  STOModel
> {
  constructor() {
    super({
      servicePath: "/SplitEmployeeDocument",
      loadItemsPath: "/ProcessSplitEmployeeDocument",
    });
  }
}
